/* eslint-disable @typescript-eslint/naming-convention */

const REACT_APP_ENV: string = process.env.REACT_APP_ENV;
const REACT_APP_GATEWAY_URL: string = process.env.REACT_APP_GATEWAY_URL;
const REACT_APP_KEYCLOAK_REALM: string = process.env.REACT_APP_KEYCLOAK_REALM;
const REACT_APP_KEYCLOAK_URL: string = process.env.REACT_APP_KEYCLOAK_URL;
const REACT_APP_KEYCLOAK_CLIENT_ID: string =
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
const REACT_APP_SOCKET_URL: string = process.env.REACT_APP_SOCKET_URL;
const REACT_APP_LOCATION_URL: string = process.env.REACT_APP_LOCATION_URL;

const SERVICE = {
  USER: 'services/user/api/v1',
  PROGRAM: 'services/program/api/v1',
  DATA: 'services/data/api/v1',
  APP: 'services/app/api/v1',
  COMMUNICATION: 'services/communication/api/v1',
  REDEEMHUB: 'services/redeemhub/api/v1',
};

const MODULE = {
  RULE_MANAGEMENT: 'rule_management',
  ORGANIZATION: 'organization',
  ROLES_PERMISSIONS: 'roles_permissions',
  INPUT_SOURCE: 'input_source',
  FREQUENCY_MANAGEMENT: 'frequency_management',
  WORKFLOW_MANAGEMENT: 'workflow_management',
  UNIFIED_DATA_SOURCE: 'unified_data_source',
  PROGRAM_CONFIGURATION_MANAGEMENT: 'program_configuration_management',
  SIMULATION_MANAGEMENT: 'simulation_management',
  USER_MANAGEMENT: 'user_management',
  DASHBOARD_MANAGEMENT: 'dashboard_management',
  TARGET_MANAGEMENT: 'target_management',
  MASTER_DATA_MANAGEMENT: 'master_data_management',
  HOLIDAY_MANAGEMENT: 'holiday_management',
  COMMUNICATION_MANAGEMENT: 'communication_management',
  QC_API_FETCH_PRODUCT: 'qc_api_fetch_product',
  CONTEST_MANAGEMENT: 'contest_management',
  QUERY_MANAGEMENT: 'query_management',
  BULK_RULE_CREATION: 'bulk_rule_creation',
  GRID_APPROVAL_WORKFLOW: 'grid_approval_workflow',
};

const buildUrl = (service: string, moduleName: string): string =>
  `${REACT_APP_GATEWAY_URL}/${service}/${moduleName}`;

const REACT_APP_API_URL: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.RULE_MANAGEMENT
);
const REACT_APP_API_URL_ORG: string = buildUrl(
  SERVICE.USER,
  MODULE.ORGANIZATION
);
const REACT_APP_API_URL_ROLE_PERM: string = buildUrl(
  SERVICE.USER,
  MODULE.ROLES_PERMISSIONS
);
const REACT_APP_API_URL_ROLE: string = REACT_APP_API_URL_ROLE_PERM;
const REACT_APP_API_URL_INPUT_SOURCE: string = buildUrl(
  SERVICE.DATA,
  MODULE.INPUT_SOURCE
);
const REACT_APP_API_URL_FREQUENCY_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.FREQUENCY_MANAGEMENT
);
const REACT_APP_API_URL_WORKFLOW_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.WORKFLOW_MANAGEMENT
);
const REACT_APP_API_URL_UNIFIED: string = buildUrl(
  SERVICE.DATA,
  MODULE.UNIFIED_DATA_SOURCE
);
const REACT_APP_API_URL_PROGRAM: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.PROGRAM_CONFIGURATION_MANAGEMENT
);
const REACT_APP_API_URL_SIMULATION: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.SIMULATION_MANAGEMENT
);
const REACT_APP_USER_API_URL: string = buildUrl(
  SERVICE.USER,
  MODULE.USER_MANAGEMENT
);
const REACT_APP_API_URL_DASHBOARD_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.DASHBOARD_MANAGEMENT
);
const REACT_APP_API_URL_TARGET_MANAGEMENT: string = buildUrl(
  SERVICE.APP,
  MODULE.TARGET_MANAGEMENT
);
const REACT_APP_API_URL_MASTER: string = buildUrl(
  SERVICE.DATA,
  MODULE.MASTER_DATA_MANAGEMENT
);
const REACT_APP_API_URL_HOLIDAY: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.HOLIDAY_MANAGEMENT
);
const REACT_APP_API_URL_COMMUNICATION_MANAGEMENT: string = buildUrl(
  SERVICE.COMMUNICATION,
  MODULE.COMMUNICATION_MANAGEMENT
);
const REACT_APP_API_URL_QC_API: string = buildUrl(
  SERVICE.REDEEMHUB,
  MODULE.QC_API_FETCH_PRODUCT
);
const REACT_APP_API_URL_CONTEST_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.CONTEST_MANAGEMENT
);
const REACT_APP_API_URL_QUERY_MANAGEMENT: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.QUERY_MANAGEMENT
);
const REACT_APP_API_BULK_RULE_CREATION: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.BULK_RULE_CREATION
);
const REACT_APP_API_URL_GRID_APPROVAL_WORKFLOW: string = buildUrl(
  SERVICE.PROGRAM,
  MODULE.GRID_APPROVAL_WORKFLOW
);

export {
  REACT_APP_ENV,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_API_URL,
  REACT_APP_API_URL_ORG,
  REACT_APP_API_URL_ROLE_PERM,
  REACT_APP_API_URL_ROLE,
  REACT_APP_API_URL_INPUT_SOURCE,
  REACT_APP_API_URL_FREQUENCY_MANAGEMENT,
  REACT_APP_API_URL_WORKFLOW_MANAGEMENT,
  REACT_APP_API_URL_UNIFIED,
  REACT_APP_API_URL_PROGRAM,
  REACT_APP_API_URL_SIMULATION,
  REACT_APP_USER_API_URL,
  REACT_APP_API_URL_DASHBOARD_MANAGEMENT,
  REACT_APP_SOCKET_URL,
  REACT_APP_LOCATION_URL,
  REACT_APP_API_URL_TARGET_MANAGEMENT,
  REACT_APP_API_URL_MASTER,
  REACT_APP_API_URL_HOLIDAY,
  REACT_APP_API_URL_COMMUNICATION_MANAGEMENT,
  REACT_APP_API_URL_QC_API,
  REACT_APP_API_URL_CONTEST_MANAGEMENT,
  REACT_APP_API_URL_QUERY_MANAGEMENT,
  REACT_APP_API_BULK_RULE_CREATION,
  REACT_APP_API_URL_GRID_APPROVAL_WORKFLOW,
};
